import genTheme from "./gen-theme";
import tiscoTheme from "./tisco-theme";
import sswThene from "./ssw-theme";

export function getThemeByName(themeName: string) {
  switch (themeName) {
    case "TISCO":
      return tiscoTheme;
    case "GENERALI":
      return genTheme;
    case "SSW":
      return sswThene;
    default:
      return genTheme;
  }
}
